import { logger } from '../../../../../../utils/logger';
import FormInput from '../../../../../../components/Form/FormInput';
import moment from 'moment';
import { usePersonalAfectado } from '../../../../../../hooks/usePersonalAfectado';
import { useDocumentoPersAfectado } from '../../../../../../hooks/useDocumentoPersAfectado';
import Table, {
  ColumnDefinitionType,
} from '../../../../../../components/Table';
import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import MyModal from '../../../../../../components/Modal';
import { DocumentoPersSubContratado } from '../../../../../../types/DocumentoPersSubContratado';
import { useDocumento } from '../../../../../../hooks/useDocumento';
import { Historial } from '../../../DocumentosAdjuntos/historial';
import {
  downloadAndOpenFile,
  downloadFile,
  findPersonalByTipoAndNumDoc,
  puedeAdjuntar,
} from '../../../../../../services/Service';
import { Button } from 'react-bootstrap';
import FormSelectBox from '../../../../../../components/Form/FormSelectBox';
import { useSolicitud } from '../../../../../../hooks/useSolicitud';
import { AgregarDocumento } from '../../DocumentoAdjunto/agregar';
import { toast } from 'react-toastify';
import {
  APROBADA_STATUS_ID,
  EN_ACTUALIZACION_STATUS_ID,
  HAB_APROBADA_STATUS_ID,
  OBSERVADA_STATUS_ID,
  REVISION_STATUS_ID,
  SIN_VISAR_DOCUMENTO_STATUS,
  SITUACION_PERSONAL_SUBCONTRATADO,
} from '../../../../../../constants/constants';
import ObservacionComponent from '../../../../../../components/Observaciones';
import { useUserLogin } from '../../../../../../hooks/useUserLogin';
import { PersonalHabilitacionContratistaService } from '../../../../../../services/PersonalHabilitacionContratistaService';
import { PersonalHabilitacion } from '../../../../../../types/PersonalHabilitacion';

interface EditPersonalSubContratadoProps {
  tiposDocumentosPers: any;
  onClose: () => void;
  onSave: (
    formData: FormData,
    currentSave: HTMLButtonElement | null,
  ) => void;
  isEditing: boolean;
  actividades: any[];
  limiteExcedido: boolean;
}

interface FormData {
  id: number;
  tipoDocumento: string;
  nroDocumento: string;
  nombre: string;
  apellido: string;
  fechaIngreso: Date | null; // Puede ser una cadena o null
  actividad: string;
  documentosPersSubContratado: any[];
  /** ids de documentos existentes que el usuario quitó explícitamente en este formulario */
  documentosEliminados: number[];
  empresa: string;
  vigente: boolean;
}

const EditPersonalSubContratado: React.FC<
  EditPersonalSubContratadoProps
> = ({
  onClose,
  isEditing,
  tiposDocumentosPers,
  actividades,
  onSave,
  limiteExcedido,
}) => {
  const {
    isContratistaTipoUsuario,
    isEmpresaGestoraTipoUsuario,
    isEmpresaSupervisoraTipoUsuario,
  } = useUserLogin();
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenAddDocumentPers, setIsOpenAddDocumentPers] =
    useState(false);
  const [
    isOpenModalConfirmDocumentDelete,
    setIsOpenModalConfirmDocumentDelete,
  ] = useState(false);
  const [actividadSelect, setActividadSelect] = useState<string>('');
  const [
    isOpenModalActividadDocumentDelete,
    setIsOpenModalActividadDocumentDelete,
  ] = useState(false);
  const { solicitudSelected } = useSolicitud();
  const [selectedIdTipoDocumento, setSelectedIdTipoDocumento] =
    useState<number>(0); // Estado para mantener el ID seleccionado
  const toggle = () => setIsOpen(!isOpen);
  const {
    personalSubContratadoSelected,
    buscarPersonalSubContratadoByIdSolicitud,
  } = usePersonalAfectado();
  const [documentoActividad, setDocumentoActividad] = useState<any[]>(
    [],
  );
  const {
    documentoPersonalSubContratadoList,
    actualizarDocumentos,
    handleDocumentoPersSubContratadoSelected,
    documentoPersonalSubContratadoSelected,
  } = useDocumentoPersAfectado();
  const {
    historialDocumentos,
    buscarDocumentosByIdTipoDocumento,
    handleDocumentoSelected,
    documentoInitial,
  } = useDocumento();
  const [
    listDocumentoPersonalSubContratado,
    setListDocumentoPersonalSubContratado,
  ] = useState<DocumentoPersSubContratado[]>([]);
  const [minDateFechaIngreso, setMinDateFechaIngreso] =
    useState<Date>();
  const [formData, setFormData] = useState<FormData>({
    id: 0,
    tipoDocumento: '',
    nroDocumento: '',
    nombre: '',
    apellido: '',
    fechaIngreso: null,
    actividad: '',
    documentosPersSubContratado: [],
    documentosEliminados: [],
    empresa: '',
    vigente: true,
  });
  const [documentosEliminados, setDocumentosEliminados] = useState<
    number[]
  >([]);

  const [
    isOpenModalObservacionDocument,
    setIsOpenModalObservacionDocument,
  ] = useState(false);
  const [isOpenModalHistorial, setIsOpenModaHistorial] =
    useState(false);
  const [showModalSalir, setShowModalSalir] =
    useState<boolean>(false);

  // CU13 (mantis 0200062): combo "Personal Habilitado" cuando el contratista tiene habilitación APROBADA
  const habilitacionAprobada =
    solicitudSelected?.idEstadoHabilitacionContratista ===
    HAB_APROBADA_STATUS_ID;
  const [personalHabilitadoList, setPersonalHabilitadoList] =
    useState<PersonalHabilitacion[]>([]);
  const [idPersonalHabilitadoSel, setIdPersonalHabilitadoSel] =
    useState<string>('');

  const { cargarCombo } = useSolicitud();
  const { getUsuario } = useUserLogin();
  const [isEmpresaGestora] = useState<boolean>(
    isEmpresaGestoraTipoUsuario(),
  );
  const [isContratista] = useState<boolean>(
    isContratistaTipoUsuario(),
  );
  const [isEmpresaSupervisora] = useState<boolean>(
    isEmpresaSupervisoraTipoUsuario(),
  );
  const [isDisabled, setDisabled] = useState<boolean>(
    ((isEmpresaGestora || isEmpresaSupervisora) &&
      solicitudSelected.idTipoEstado == REVISION_STATUS_ID) ||
      (isContratista &&
        solicitudSelected.idTipoEstado == REVISION_STATUS_ID),
  );
  const [saveRevision, setSaveRevision] = useState(false);
  const [estados] = useState<any>([
    {
      id: true,
      valor: 'Activo',
    },
    {
      id: false,
      valor: 'Inactivo',
    },
  ]);
  let btnRef = useRef<HTMLButtonElement>(null);

  const handleDocumento = async (id: number) => {
    setSelectedIdTipoDocumento(id);
    setIsOpenModaHistorial(true);
  };
  const getDocumentoSelected = (id: number) => {
    if (id) {
      const doc =
        historialDocumentos.find((d) => d.idTipoDocumento === id) ||
        documentoInitial;
      handleDocumentoSelected(doc);
      toggle();
      setSelectedIdTipoDocumento(0);
    }
  };

  useEffect(() => {
    if (solicitudSelected.fechaInicio) {
      let dateInicioValue = moment(
        solicitudSelected.fechaInicio,
      ).toDate();
      setMinDateFechaIngreso(dateInicioValue);
    }
    if (isEditing && personalSubContratadoSelected.id !== 0) {
      // Si estás en modo edición, puedes cargar los datos existentes en el estado formData
      // Utiliza los datos cargados para inicializar formData
      // Ejemplo:
      setFormData({
        id: personalSubContratadoSelected.id,
        tipoDocumento: personalSubContratadoSelected.idTipoDocumento,
        nombre: personalSubContratadoSelected.nombre,
        actividad: personalSubContratadoSelected.idActividad,
        apellido: personalSubContratadoSelected.apellido,
        fechaIngreso:
          personalSubContratadoSelected.fechaIngreso &&
          personalSubContratadoSelected.fechaIngreso !== ''
            ? moment(
                personalSubContratadoSelected.fechaIngreso,
                'YYYY-MM-DD',
              ).toDate()
            : null,
        nroDocumento: personalSubContratadoSelected.nroDocumento,
        documentosPersSubContratado:
          documentoPersonalSubContratadoList,
        documentosEliminados: [],
        empresa: personalSubContratadoSelected.empresa,
        vigente: personalSubContratadoSelected.vigente,
      });
      cargarCombo(
        `documentoActividad/actividad/${personalSubContratadoSelected.idActividad}`,
        setDocumentoActividad,
      );
    }
    setDisabled(
      ((isEmpresaGestora || isEmpresaSupervisora) &&
        solicitudSelected.idTipoEstado == REVISION_STATUS_ID) ||
        (isContratista &&
          solicitudSelected.idTipoEstado == REVISION_STATUS_ID),
    );
  }, []);

  // CU13 (mantis 0200062): carga el personal habilitado para esta solicitud (situación SUBCONTRATADO)
  useEffect(() => {
    if (habilitacionAprobada && solicitudSelected?.idContratista) {
      PersonalHabilitacionContratistaService.findHabilitadoParaSolicitud(
        solicitudSelected.idContratista,
        SITUACION_PERSONAL_SUBCONTRATADO,
      )
        .then(setPersonalHabilitadoList)
        .catch(() => setPersonalHabilitadoList([]));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangePersonalHabilitado = (e: any) => {
    const id = e.target.value;
    setIdPersonalHabilitadoSel(id);
    if (!id) {
      return;
    }
    const persona = personalHabilitadoList.find(
      (p) => String(p.id) === String(id),
    );
    if (persona) {
      setFormData({
        ...formData,
        tipoDocumento: String(persona.idTipoDocPersona ?? ''),
        nroDocumento: persona.nroDocumento ?? '',
        nombre: persona.nombre ?? '',
        apellido: persona.apellido ?? '',
      });
    }
  };

  const personalHabilitadoOptions = personalHabilitadoList.map(
    (p) => ({
      ...p,
      etiquetaPersonalHabilitado: `${p.apellido}, ${p.nombre} (${p.tipoDocPersona} ${p.nroDocumento})`,
    }),
  );

  // CU13 (mantis 0200062): solo se ofrece el combo cuando hay personal habilitado disponible
  // para esta habilitación + situación contractual. Si la lista vino vacía, el alta/edición
  // se comporta igual que cuando el contratista no tiene habilitación aprobada (carga manual).
  const mostrarComboHabilitado =
    habilitacionAprobada && personalHabilitadoList.length > 0;
  // CU13 (mantis 0200062): la persona del formulario es habilitada si coincide (tipo + nro
  // de documento) con alguien de la lista de habilitados. Cubre la edición y el caso de
  // tipear el DNI de un habilitado sin usar el combo. PersonalPropioDTO no expone idPersonal,
  // por eso el cruce es por documento.
  const personaEsHabilitada = personalHabilitadoList.some(
    (p) =>
      String(p.nroDocumento) === String(formData.nroDocumento) &&
      String(p.idTipoDocPersona) === String(formData.tipoDocumento),
  );
  const personalHabilitadoLock =
    mostrarComboHabilitado &&
    (idPersonalHabilitadoSel !== '' || personaEsHabilitada);

  useEffect(() => {
    if (documentoPersonalSubContratadoList.length > 0) {
      setListDocumentoPersonalSubContratado((prevList) => {
        // Se conservan los archivos ya seleccionados por el usuario y los documentos nuevos
        // (id 0) para que una recarga de la lista del servidor no pierda su trabajo.
        const nuevosLocales = prevList.filter(
          (item) =>
            item.id === 0 &&
            !documentoPersonalSubContratadoList.some(
              (documento) => documento.idTipoDocumento === item.idTipoDocumento,
            ),
        );
        const desdeServidor = documentoPersonalSubContratadoList.map((documento) => {
          const local = prevList.find(
            (item) =>
              item.id === documento.id &&
              item.idTipoDocumento === documento.idTipoDocumento &&
              item.archivoSeleccionado,
          );
          if (local) {
            return local;
          }
          return {
            id: documento.id,
            idTipoDocumento: documento.idTipoDocumento,
            tipoDocumento: documento.tipoDocumento,
            nombreArchivo: documento.nombreArchivo,
            fileId: documento.fileId,
            subido: documento.subido,
            ubicacion: documento.ubicacion,
            fechaVencimiento: documento.fechaVencimiento,
            formatoArchivo: documento.formatoArchivo,
            nombreTipoDocumento: documento.nombreTipoDocumento,
            idSolicitud: solicitudSelected.id,
            archivoSeleccionado: null,
            statusDocumento: documento.statusDocumento,
            observacion: documento.observacion,
            sizeMaximo: documento.sizeMaximo,
            idUsuarioRevisor: documento.idUsuarioRevisor,
            nombreUsuarioRevisor: documento.nombreUsuarioRevisor,
            apellidoUsuarioRevisor: documento.apellidoUsuarioRevisor,
          };
        });
        return [...desdeServidor, ...nuevosLocales];
      });
    } else {
      setListDocumentoPersonalSubContratado((prevList) =>
        prevList.filter((item) => item.id === 0),
      );
    }
  }, [documentoPersonalSubContratadoList]);

  useEffect(() => {
    // Dependiendo de cómo se use historialDocumentos, podrías necesitar un efecto para manejar su actualización
    // Realiza las acciones que necesites con el historialDocumentos actualizado aquí
    getDocumentoSelected(selectedIdTipoDocumento);
  }, [historialDocumentos]);
  const columns: ColumnDefinitionType<
    DocumentoPersSubContratado,
    keyof DocumentoPersSubContratado
  >[] = [];
  columns.push({
    key: 'tipoDocumento',
    header: 'TIpo Documento',
  });
  columns.push({
    key: 'nombreArchivo',
    header: 'Nombre',
  });
  columns.push({
    key: 'fechaVencimiento',
    header: 'Fecha Vencimiento',
    cell: (data: DocumentoPersSubContratado) => {
      const isExpired =
        data.fechaVencimiento &&
        moment(data.fechaVencimiento).isBefore(moment(), 'day');
      return (
        <span style={{ color: isExpired ? 'red' : 'inherit' }}>
          {data.fechaVencimiento
            ? moment(data.fechaVencimiento).format('DD/MM/YYYY')
            : ''}
        </span>
      );
    },
  });
  columns.push({
    key: 'idUsuarioRevisor',
    header: 'Revisor',
    cell: (data: DocumentoPersSubContratado) => (
      <>
        {data.nombreUsuarioRevisor && data.apellidoUsuarioRevisor
          ? `${data.apellidoUsuarioRevisor}, ${data.nombreUsuarioRevisor}`
          : ''}
      </>
    ),
  });
  if (
    isContratistaTipoUsuario() &&
    solicitudSelected.idTipoEstado === OBSERVADA_STATUS_ID
  ) {
    columns.push({
      key: 'observacion',
      header: 'Observaciones',
      cell: (data: DocumentoPersSubContratado) => (
        <>
          {data.observacion && (
            <a
              href="#"
              title="Observaciones"
              onClick={() => {
                handleDocumentoPersSubContratadoSelected(data);
                setIsOpenModalObservacionDocument(true);
              }}
            >
              <i
                className="fa fa-search me-2"
                style={{ color: 'red' }}
                aria-hidden="true"
              ></i>
            </a>
          )}
        </>
      ),
    });
  }
  columns.push({
    key: 'id',
    header: 'Acciones',
    cell: (data: DocumentoPersSubContratado) => (
      <>
        <Link
          title="Visualizar"
          to="/exportar"
          onClick={(e) => {
            e.preventDefault();
            downloadAndOpenFile(
              'documento-personal/visualizarArchivo',
              data,
            );
          }}
          target="_blank"
        >
          <i
            className="fa fa-eye text-secondary me-2"
            aria-hidden="true"
          ></i>
        </Link>
        <Link
          title="Descargar"
          to="/exportar"
          onClick={(e) => {
            e.preventDefault();
            downloadFile('documento-personal/descargarArchivo', data);
          }}
          target="_blank"
        >
          <i
            className="fa fa-arrow-down text-secondary me-2"
            aria-hidden="true"
          ></i>
        </Link>
        {/* Una vez aprobada la solicitud los documentos guardados forman parte del histórico: solo se reemplazan
            por una nueva versión. Las filas recién agregadas (id 0) todavía se pueden quitar. */}
        {!isDisabled &&
          !(solicitudSelected.fueAprobada && data.id !== 0) &&
          solicitudSelected.idTipoEstado !== OBSERVADA_STATUS_ID &&
          solicitudSelected.idTipoEstado !== APROBADA_STATUS_ID && (
            <Link
              title="Eliminar"
              to="/delete"
              onClick={(e) => {
                e.preventDefault();
                setIsOpenModalConfirmDocumentDelete(true);
                setSelectedIdTipoDocumento(data.idTipoDocumento);
              }}
              target="_blank"
            >
              <i
                className="fa fa-trash text-secondary me-2"
                aria-hidden="true"
              ></i>
            </Link>
          )}
        {(isEmpresaGestoraTipoUsuario() ||
          isEmpresaSupervisoraTipoUsuario()) &&
          solicitudSelected.idTipoEstado === REVISION_STATUS_ID && (
            <a
              href="#"
              title="Observaciones"
              onClick={() => {
                handleDocumentoPersSubContratadoSelected(data);
                setIsOpenModalObservacionDocument(true);
              }}
            >
              <i
                className="fa fa-search text-secondary me-2"
                aria-hidden="true"
              ></i>
            </a>
          )}
        {(((isEmpresaGestoraTipoUsuario() ||
          isEmpresaSupervisoraTipoUsuario()) &&
          solicitudSelected.idTipoEstado === REVISION_STATUS_ID) ||
          (isContratistaTipoUsuario() &&
            (solicitudSelected.idTipoEstado === OBSERVADA_STATUS_ID ||
              solicitudSelected.idTipoEstado ===
                EN_ACTUALIZACION_STATUS_ID ||
              solicitudSelected.idTipoEstado ===
                APROBADA_STATUS_ID))) && (
          <a
            href="#"
            title="Historial de Documentos"
            onClick={() => handleDocumento(data.idTipoDocumento)}
          >
            <i
              className="fa fa-history text-secondary "
              aria-hidden="true"
            ></i>
          </a>
        )}
      </>
    ),
  });
  columns.push({
    key: 'statusDocumento',
    header: '',
    isEnabledCheckStatusDocument:
      (isEmpresaGestoraTipoUsuario() ||
        isEmpresaSupervisoraTipoUsuario()) &&
      solicitudSelected.idTipoEstado === REVISION_STATUS_ID,
  });

  const handleChangeTipoDocumento = (e: any) => {
    e.preventDefault();
    const idTipoDocumento = e.target.value;
    personalSubContratadoSelected.tipoDocumento = idTipoDocumento;
  };

  const handleInputChange = (name: string, value: any) => {
    // Actualiza el estado con el nuevo valor
    if (name === 'actividad') {
      if (listDocumentoPersonalSubContratado.length > 0) {
        setIsOpenModalActividadDocumentDelete(true);
        setActividadSelect(value);
        return;
      }
      if (value != null && value !== '') {
        cargarCombo(
          `documentoActividad/actividad/${value}`,
          setDocumentoActividad,
        );
      }
    }
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleInputChangeNumDoc = (name: string, value: any) => {
    let tipoDoc: string = '';
    let numDocumento: string = '';

    if (name === 'nroDocumento') {
      numDocumento = value;
      tipoDoc = formData.tipoDocumento;
    } else if (name === 'tipoDocumento') {
      numDocumento = formData.nroDocumento;
      tipoDoc = value;
    }

    if (tipoDoc !== '' && numDocumento !== '') {
      findPersonalByTipoAndNumDoc(
        parseInt(tipoDoc),
        numDocumento,
      ).then(async (respuesta) => {
        if (respuesta && respuesta.data) {
          // CU13 (mantis 0200062): si la persona pertenece a la habilitación del contratista,
          // solo puede usarse en el bloque cuya situación contractual coincida.
          if (habilitacionAprobada && solicitudSelected?.idContratista) {
            const situaciones =
              await PersonalHabilitacionContratistaService.findSituacionesHabilitado(
                solicitudSelected.idContratista,
                parseInt(tipoDoc),
                numDocumento,
              ).catch(() => [] as string[]);
            if (
              situaciones.length > 0 &&
              !situaciones.includes(SITUACION_PERSONAL_SUBCONTRATADO)
            ) {
              // No pertenece a este bloque: no se trae la persona (sin error, sin bloqueo).
              setFormData({
                ...formData,
                [name]: value,
                nombre: '',
                apellido: '',
              });
              return;
            }
          }
          setFormData({
            ...formData,
            [name]: value,
            nombre: respuesta.data.nombre,
            apellido: respuesta.data.apellido,
          });
        } else {
          setFormData({
            ...formData,
            [name]: value,
          });
        }
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
    // logger.log(formData);
  };

  const handleOpenAddDocumentPerson = () => {
    if (formData.actividad) {
      cargarCombo(
        `documentoActividad/actividad/${formData.actividad}`,
        setDocumentoActividad,
      );
      setIsOpenAddDocumentPers(true);
    } else {
      toast.error('Por favor, seleccionar una Actividad.');
    }
  };

  const validationPreSavedPersonalSubContratado = () => {
    if (
      (isEmpresaGestora || isEmpresaSupervisora) &&
      solicitudSelected.idTipoEstado == REVISION_STATUS_ID
    ) {
      btnRef!.current!.disabled = true;
      saveRevisionButtonFn();
      onClose();
    } else {
      if (!formData.tipoDocumento) {
        toast.error('Por favor, seleccionar un Tipo de Documento.');
        return;
      }

      if (!formData.nroDocumento) {
        toast.error('Por favor, completar el número Documento.');
        return;
      }

      if (!formData.nombre) {
        toast.error('Por favor, completar el nombre.');
        return;
      }

      if (!formData.apellido) {
        toast.error('Por favor, completar el apellido.');
        return;
      }

      if (!formData.actividad) {
        toast.error('Por favor, seleccionar una Actividad.');
        return;
      }

      if (!formData.empresa) {
        toast.error('Por favor, completar la empresa.');
        return;
      }

      btnRef!.current!.disabled = true;

      formData.documentosPersSubContratado =
        listDocumentoPersonalSubContratado;
      formData.documentosEliminados = documentosEliminados;
      // El control de vencimiento aplica siempre que la solicitud haya sido aprobada alguna vez
      // (también en Observada posterior a una aprobación).
      if (solicitudSelected.fueAprobada) {
        // findDeletedDocuments(data.documentosPersSubContratado).forEach(documentDelete => deleteDocPersById('documento-personal-subcontratado', documentDelete.id));
        let documentUpload =
          formData.documentosPersSubContratado.filter(
            (documentPersPropio: any) =>
              documentPersPropio.archivoSeleccionado,
          );
        if (documentUpload.length >= 1) {
          (async () => {
            try {
              let documentos = documentUpload.map(
                (documentPersPropio: any) => {
                  return {
                    ...documentPersPropio,
                    archivoSeleccionado: null,
                  };
                },
              );
              let puedeAdj = await puedeAdjuntar(
                `documento-personal-subcontratado`,
                documentos,
              );

              if (!puedeAdj) {
                toast.error(
                  'Se pueden adjuntar Tipos de Documentos vencidos, próximos a vencerse o no obligatorios',
                );
                btnRef!.current!.disabled = false;
                return;
              } else {
                onSave(formData, btnRef!.current);
                // onClose();
              }
            } catch (error) {
              logger.error(
                'Error al verificar la fecha de vencimiento del documento:',
                error,
              );
            }
          })();
        } else {
          onSave(formData, btnRef!.current);
          // onClose();
        }
      } else {
        onSave(formData, btnRef!.current);
        if (limiteExcedido) {
          btnRef!.current!.disabled = false;
        } else {
          btnRef!.current!.disabled = true;
        }
      }
    }
  };

  const addDocumentConfirmSave = (data: any) => {
    const documentoExistente =
      listDocumentoPersonalSubContratado.find(
        (doc) => doc.idTipoDocumento === data.idTipoDocumento,
      );

    if (documentoExistente) {
      // Si el documento ya existe, reemplaza el existente con el nuevo documento.
      let replaceDocument = { ...documentoExistente };
      replaceDocument.archivoSeleccionado = data.archivoSeleccionado;
      replaceDocument.idSolicitud = solicitudSelected.id;
      replaceDocument.tipoDocumento = data.tipoDocumento;
      replaceDocument.nombreArchivo = data.archivoSeleccionado.name;
      replaceDocument.statusDocumento = '';
      replaceDocument.observacion = '';
      replaceDocument.sizeMaximo = data.sizeMaximo;
      replaceDocument.fechaVencimiento = data.fechaVencimiento ?? '';
      replaceDocumentoPersSubContratadoByIdTipoDocumento(
        replaceDocument,
      );
    } else {
      // Si el documento no existe, simplemente agrégalo al array.
      let documentoPersSubContratadoInitial: DocumentoPersSubContratado =
        {
          id: 0,
          idTipoDocumento: data.idTipoDocumento,
          tipoDocumento: data.tipoDocumento,
          nombreArchivo: data.archivoSeleccionado.name,
          fileId: 0,
          subido: false,
          ubicacion: '',
          fechaVencimiento: data.fechaVencimiento ?? '',
          formatoArchivo: '',
          nombreTipoDocumento: '',
          idSolicitud: solicitudSelected.id,
          archivoSeleccionado: data.archivoSeleccionado,
          statusDocumento: '',
          observacion: '',
          sizeMaximo: data.sizeMaximo,
        };
      setListDocumentoPersonalSubContratado((prevList) => [
        ...prevList,
        documentoPersSubContratadoInitial,
      ]);
    }
  };

  const replaceDocumentoPersSubContratadoByIdTipoDocumento = (
    nuevoElemento: DocumentoPersSubContratado,
  ) => {
    setListDocumentoPersonalSubContratado((prevList) => {
      return prevList.map((item) => {
        if (item.idTipoDocumento === nuevoElemento.idTipoDocumento) {
          return nuevoElemento; // Reemplazar el elemento si se encuentra
        }
        return item; // Mantener el elemento sin cambios si no coincide el ID
      });
    });
  };

  const deleteDocumentoPersSubContratadoByIdTipoDocumento = (
    idTipoDocumentoAEliminar: number,
  ) => {
    const eliminados = listDocumentoPersonalSubContratado
      .filter(
        (item) => item.idTipoDocumento === idTipoDocumentoAEliminar && item.id,
      )
      .map((item) => item.id);
    if (eliminados.length > 0) {
      setDocumentosEliminados((prev) => [...prev, ...eliminados]);
    }
    setListDocumentoPersonalSubContratado((prevList) => {
      return prevList.filter(
        (item) => item.idTipoDocumento !== idTipoDocumentoAEliminar,
      );
    });
  };

  const handleConfirmDeleteDocument = () => {
    deleteDocumentoPersSubContratadoByIdTipoDocumento(
      selectedIdTipoDocumento,
    );
    setIsOpenModalConfirmDocumentDelete(false);
  };

  const handleConfirmActividadDeleteAllDocument = () => {
    // Al cambiar de actividad/equipo se quitan todos los documentos: los ya existentes en el servidor
    // se registran como eliminados explícitamente para que el guardado los dé de baja.
    const existentes = listDocumentoPersonalSubContratado
      .filter((item) => item.id)
      .map((item) => item.id);
    if (existentes.length > 0) {
      setDocumentosEliminados((prev) => [...prev, ...existentes]);
    }
    setListDocumentoPersonalSubContratado([]);
    setFormData({
      ...formData,
      actividad: actividadSelect,
    });
    cargarCombo(
      `documentoActividad/actividad/${actividadSelect}`,
      setDocumentoActividad,
    );
    setIsOpenModalActividadDocumentDelete(false);
  };

  const onCheckboxChange = (
    data: DocumentoPersSubContratado,
    status: string,
  ) => {
    const usuario = getUsuario();
    setSaveRevision(true);
    setListDocumentoPersonalSubContratado((prevList: any) => {
      return prevList.map((item: any) => {
        if (data.id === item.id) {
          // Modificamos solo el elemento deseado
          return {
            ...item,
            statusDocumento: status,
            idUsuarioRevisor: usuario?.id,
            nombreUsuarioRevisor: usuario?.nombre,
            apellidoUsuarioRevisor: usuario?.apellido,
          };
        }
        // Mantenemos los demás elementos sin cambios
        return item;
      });
    });
  };

  const onObservacionChange = (observacion: string) => {
    setIsOpenModalObservacionDocument(false);
    setListDocumentoPersonalSubContratado((prevList: any) => {
      return prevList.map((item: any) => {
        if (documentoPersonalSubContratadoSelected.id === item.id) {
          // Modificamos solo el elemento deseado
          return { ...item, observacion: observacion };
        }
        // Mantenemos los demás elementos sin cambios
        return item;
      });
    });
  };

  const saveRevisionButtonFn = () => {
    const documentoUpdateStatus = [];
    for (const documento of listDocumentoPersonalSubContratado) {
      documentoUpdateStatus.push({
        id: documento.id,
        statusDocumento: documento.statusDocumento,
        observacion: documento.observacion,
        idUsuarioRevisor: documento.idUsuarioRevisor,
        nombreUsuarioRevisor: documento.nombreUsuarioRevisor,
        apellidoUsuarioRevisor: documento.apellidoUsuarioRevisor,
      });
    }

    actualizarDocumentos(
      documentoUpdateStatus,
      'documento-personal-subcontratado',
    )
      .then((respuesta) => {
        buscarPersonalSubContratadoByIdSolicitud(
          solicitudSelected.id,
        );
        toast.success('Se actualizaron los documentos revisados');
      })
      .catch((error) => {
        toast.error('Error al actualizar los documentos revisados');
      });
  };
  const toggleSalir = () => {
    setShowModalSalir(!showModalSalir);
  };
  const onCloseSalir = () => {
    setShowModalSalir(!showModalSalir);
    onClose();
  };

  return (
    <>
      <MyModal
        isOpen={isOpenModalObservacionDocument}
        toggle={() => setIsOpenModalObservacionDocument(false)}
        title="Observaciones"
        cancelButton={false}
        secondButton={false}
      >
        <ObservacionComponent
          observacion={
            documentoPersonalSubContratadoSelected.observacion
          }
          saveButtonFn={onObservacionChange}
          isEdit={!isContratista}
          cancelButtonFn={() =>
            setIsOpenModalObservacionDocument(false)
          }
          returnButtonFn={() =>
            setIsOpenModalObservacionDocument(false)
          }
        ></ObservacionComponent>
      </MyModal>
      <MyModal
        isOpen={isOpenModalActividadDocumentDelete}
        toggle={() => setIsOpenModalActividadDocumentDelete(false)}
        title="Advertencia"
        cancelButton={true}
        secondButton={true}
        secondButtonTitle={'Aceptar'}
        titleCancelar={'Cancelar'}
        secondButtonFn={handleConfirmActividadDeleteAllDocument}
      >
        <label>
          Si cambia la Actividad se van a eliminar los documentos
          adjuntados. Desea confirmar?
        </label>
      </MyModal>
      <MyModal
        isOpen={isOpenModalConfirmDocumentDelete}
        toggle={() => setIsOpenModalConfirmDocumentDelete(false)}
        title="Advertencia"
        cancelButton={true}
        secondButton={true}
        secondButtonTitle={'Aceptar'}
        titleCancelar={'Cancelar'}
        secondButtonFn={handleConfirmDeleteDocument}
      >
        <label>Confirma la eliminación del registro?</label>
      </MyModal>
      {/* <MyModal isOpen={isOpen} toggle={toggle} title='Historial de Documentos'>
                <Historial tipoDocumentoDisabled={true} />
            </MyModal> */}
      <MyModal
        isOpen={isOpenModalHistorial}
        toggle={() => setIsOpenModaHistorial(false)}
        title="Historial de Documentos"
      >
        <Historial
          tipoDocumentoDisabled={true}
          pathService={`documento-personal-subcontratado/personal-subcontratado/${personalSubContratadoSelected.id}`}
          idTipoDocumentoSelected={selectedIdTipoDocumento}
        />
      </MyModal>
      <MyModal
        isOpen={isOpenAddDocumentPers}
        toggle={() => setIsOpenAddDocumentPers(false)}
        title="Agregar Documentos"
        enabledFooter={false}
      >
        <AgregarDocumento
          tipoDocumentoDisabled={true}
          cancelButtonFn={() => setIsOpenAddDocumentPers(false)}
          listDocumentos={listDocumentoPersonalSubContratado}
          saveCompletedButtonFn={(addDocument) => {
            addDocumentConfirmSave(addDocument);
          }}
          documentoActividad={documentoActividad}
        />
      </MyModal>
      <MyModal
        isOpen={showModalSalir}
        toggle={toggleSalir}
        title="Advertencia"
        cancelButton={true}
        secondButton={true}
        secondButtonTitle={'Aceptar'}
        secondButtonFn={onCloseSalir}
      >
        <label>Desea Salir sin guardar los cambios?</label>
      </MyModal>
      <div>
        {mostrarComboHabilitado && (
          <div className="row mt-2">
            <FormSelectBox
              id={'personalHabilitado'}
              label={'Personal Habilitado'}
              name={'personalHabilitado'}
              value={idPersonalHabilitadoSel}
              title={'Personal Habilitado'}
              onChange={handleChangePersonalHabilitado}
              optionId={'id'}
              optionLabel={'etiquetaPersonalHabilitado'}
              options={personalHabilitadoOptions}
              classLabel="col-form-label col-2 text-end"
              classDivSelect="col-4"
            />
          </div>
        )}
        <div className="row mt-2">
          <FormSelectBox
            id={'tipoDocumento'}
            label={'Tipo Doc Persona'}
            name={'tipoDocumento'}
            value={formData.tipoDocumento || ''}
            isDisabled={
              solicitudSelected.idTipoEstado === REVISION_STATUS_ID ||
              (formData.id !== 0 &&
                (solicitudSelected.idTipoEstado ===
                  APROBADA_STATUS_ID ||
                  solicitudSelected.idTipoEstado ===
                    EN_ACTUALIZACION_STATUS_ID)) ||
              personalHabilitadoLock
            }
            title={'Tipo Doc Persona'}
            onChange={(e) =>
              handleInputChangeNumDoc(e.target.name, e.target.value)
            }
            optionId={'id'}
            optionLabel={'tipoDocumento'}
            options={tiposDocumentosPers}
            classLabel="col-form-label col-2 text-end"
            classDivSelect="col-4"
          />
          <FormInput
            id={'nroDocumento'}
            label={'Nro. Documento'}
            name={'nroDocumento'}
            value={formData.nroDocumento || ''}
            onChange={(e) =>
              handleInputChangeNumDoc(e.target.name, e.target.value)
            }
            isDisabled={
              solicitudSelected.idTipoEstado === REVISION_STATUS_ID ||
              (formData.id !== 0 &&
                (solicitudSelected.idTipoEstado ===
                  APROBADA_STATUS_ID ||
                  solicitudSelected.idTipoEstado ===
                    EN_ACTUALIZACION_STATUS_ID)) ||
              personalHabilitadoLock
            }
          />
        </div>
        <div className="row mt-2">
          <FormInput
            id={'nombre'}
            label={'Nombre'}
            name={'nombre'}
            value={formData.nombre || ''}
            onChange={(e) =>
              handleInputChange(e.target.name, e.target.value)
            }
            maxLength={50}
            isDisabled={
              solicitudSelected.idTipoEstado === REVISION_STATUS_ID ||
              (formData.id !== 0 &&
                (solicitudSelected.idTipoEstado ===
                  APROBADA_STATUS_ID ||
                  solicitudSelected.idTipoEstado ===
                    EN_ACTUALIZACION_STATUS_ID)) ||
              personalHabilitadoLock
            }
          />
          <FormInput
            id={'apellido'}
            label={'Apellido'}
            name={'apellido'}
            value={formData.apellido || ''}
            onChange={(e) =>
              handleInputChange(e.target.name, e.target.value)
            }
            maxLength={50}
            isDisabled={
              solicitudSelected.idTipoEstado === REVISION_STATUS_ID ||
              (formData.id !== 0 &&
                (solicitudSelected.idTipoEstado ===
                  APROBADA_STATUS_ID ||
                  solicitudSelected.idTipoEstado ===
                    EN_ACTUALIZACION_STATUS_ID)) ||
              personalHabilitadoLock
            }
          />
        </div>
        <div className="row mt-2">
          <FormInput
            id={'fechaIngreso'}
            label={'Fecha Ingreso Trabajo'}
            type="date"
            name={'fechaIngreso'}
            value={formData.fechaIngreso}
            onDateChange={(date: Date | null, name: string) => {
              handleInputChange(name, date);
            }}
            minDate={minDateFechaIngreso}
            isDisabled={
              solicitudSelected.idTipoEstado === REVISION_STATUS_ID ||
              (formData.id !== 0 &&
                (solicitudSelected.idTipoEstado ===
                  APROBADA_STATUS_ID ||
                  solicitudSelected.idTipoEstado ===
                    EN_ACTUALIZACION_STATUS_ID))
            }
          />
          <FormInput
            id={'empresa'}
            label={'Empresa'}
            name={'empresa'}
            value={formData.empresa || ''}
            onChange={(e) =>
              handleInputChange(e.target.name, e.target.value)
            }
            isDisabled={
              solicitudSelected.idTipoEstado === REVISION_STATUS_ID ||
              (formData.id !== 0 &&
                (solicitudSelected.idTipoEstado ===
                  APROBADA_STATUS_ID ||
                  solicitudSelected.idTipoEstado ===
                    EN_ACTUALIZACION_STATUS_ID))
            }
          />
        </div>
        <div className="row mt-2">
          <FormSelectBox
            id={'actividad'}
            label={'Actividad'}
            name={'actividad'}
            value={formData.actividad || ''}
            isDisabled={
              solicitudSelected.idTipoEstado === REVISION_STATUS_ID ||
              (formData.id !== 0 &&
                (solicitudSelected.idTipoEstado ===
                  APROBADA_STATUS_ID ||
                  solicitudSelected.idTipoEstado ===
                    EN_ACTUALIZACION_STATUS_ID))
            }
            title={'Actividad'}
            onChange={(e) =>
              handleInputChange(e.target.name, e.target.value)
            }
            optionId={'id'}
            optionLabel={'nombreActividad'}
            options={actividades}
            classLabel="col-form-label col-2 text-end"
            classDivSelect="col-4"
          />
        </div>
        {(solicitudSelected.idTipoEstado === APROBADA_STATUS_ID ||
          solicitudSelected.idTipoEstado ===
            EN_ACTUALIZACION_STATUS_ID) && (
          <div className="row mt-2">
            <FormSelectBox
              id={'vigente'}
              label={'Estado'}
              name={'vigente'}
              value={formData.vigente || ''}
              // isDisabled={formData.id !== 0}
              title={'Estado'}
              onChange={(e) =>
                handleInputChange(e.target.name, e.target.value === 'true')
              }
              optionId={'id'}
              optionLabel={'valor'}
              options={estados}
              classLabel="col-form-label col-2 text-end"
              classDivSelect="col-4"
            />
          </div>
        )}
      </div>
      <div className="p-3">
        <div className="row">
          <div className="col-md-12 text-end">
            {!isDisabled && (
              <Button
                disabled={
                  isDisabled ||
                  !formData.vigente ||
                  documentoActividad.length === 0
                }
                className="btn-secondary"
                variant="secondary"
                onClick={() => handleOpenAddDocumentPerson()}
              >
                {' '}
                Agregar Documentos
              </Button>
            )}
          </div>
        </div>
        <div className="table-responsive ">
          <Table
            data={listDocumentoPersonalSubContratado}
            columns={columns}
            onCheckboxChange={onCheckboxChange}
          ></Table>
          <div className="col-md-12 d-flex justify-content-end mt-3"></div>
        </div>
      </div>
      <div className="col-md-12 d-flex justify-content-center">
        <Button
          color="secondary"
          onClick={validationPreSavedPersonalSubContratado}
          className="mr-2"
          ref={btnRef}
        >
          Guardar
        </Button>
        <Button
          color="secondary"
          onClick={toggleSalir}
          className="mr-2"
        >
          Salir
        </Button>
      </div>
    </>
  );
};

export default EditPersonalSubContratado;
